import { ErrorOutline } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { GenAlertDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

export default function NewOrderCreationAttentionModal({
  open,
  onClose,
  storeNames = [],
}) {
  const { t } = useTranslation(['orders', 'global']);
  const descriptionKey =
    storeNames.length > 1
      ? 'NewOrderCreationAttention.description2'
      : 'NewOrderCreationAttention.description1';

  return (
    <GenAlertDialog
      open={open}
      onClose={onClose}
      title={t('NewOrderCreationAttention.title')}
      titleVariant="h4"
      titleIconColor={'error'}
      closeText={t('NewOrderCreationAttention.close')}
      titleIcon={ErrorOutline}
    >
      <Grid
        container
        direction={'row'}
        alignItems="center"
        justifyContent={'center'}
      >
        <Grid item>
          <Typography variant="Body1">
            {t(descriptionKey, { storeName: storeNames.join(', ') })}
          </Typography>
        </Grid>
      </Grid>
    </GenAlertDialog>
  );
}
